import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
const queryString = require('query-string')

import PurchaseOrderLinesToAddListing from "../../order/purchaseorderlinestoadd.listing.component.jsx";
import PurchaseOrderLinesAddedListing from "../../order/purchaseorderlinesadded.listing.component.jsx";

class Orders extends Component {

    constructor(props, context) {
        super(props, context)
        const uri = queryString.parse(this.props.location.search)

        this.state = {
            purchaseOrderExternalId: uri.purchaseOrderExternalId,
            newRowsForToAddListing: [],
            newRowsForAddedListing: [],
        }
    }

    render() {
        return (
            [
                <PurchaseOrderLinesAddedListing purchaseOrderExternalId={this.state.purchaseOrderExternalId}
                    addedRows={this.state.newRowsForAddedListing}
                    onRowsRemoved={(addedRows) => {
                        this.setState({
                            newRowsForToAddListing: addedRows
                        }, () => {
                            this.setState({
                                newRowsForToAddListing: [],
                            })
                        })
                    }} />,
                <PurchaseOrderLinesToAddListing purchaseOrderExternalId={this.state.purchaseOrderExternalId}
                    addedRows={this.state.newRowsForToAddListing}
                    onRowsRemoved={(addedRows) => {
                        this.setState({
                            newRowsForAddedListing: addedRows
                        }, () => {
                            this.setState({
                                newRowsForAddedListing: [],
                            })
                        })
                    }} />]
        )
    }
}

export default injectIntl(Orders)


// WEBPACK FOOTER //
// ./src/embed/ls-retail/orders.component.jsx